import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { NgTemplateOutlet } from '@angular/common';
import { TranslocoPipe } from '@jsverse/transloco';
import {
  ChevronDownIconComponent,
  GlobeIconComponent,
  LogoutIconComponent,
  MonitorIconComponent,
  WorkspaceIconComponent,
} from '@kuiper/icons';
import { ProfileDropdownItem } from '../../profile-dropdown.model';
import { ProfileDropdownItemSlugs } from '../../profile-dropdown.constants';

@Component({
  selector: 'lib-profile-dropdown-menu-item',
  imports: [
    NgTemplateOutlet,
    ChevronDownIconComponent,
    TranslocoPipe,
    LogoutIconComponent,
    GlobeIconComponent,
    WorkspaceIconComponent,
    MonitorIconComponent,
  ],
  templateUrl: './profile-dropdown-menu-item.component.html',
  styleUrl: './profile-dropdown-menu-item.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class ProfileDropdownMenuItemComponent {
  readonly ProfileDropdownItemSlugs = ProfileDropdownItemSlugs;

  item = input.required<ProfileDropdownItem>();
  action = output<ProfileDropdownItem>();

  onItemClick() {
    this.action.emit(this.item());
  }
}
